module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    class: {
      'pa-4 condominium-box': true, 'editing': !_vm.scheduleEditing && _vm.value.id !== ''
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.scheduleEditing) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.value.condominium.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Endereço:")]), _vm._v(" " + _vm._s(_vm.value.condominium.address) + ", " + _vm._s(_vm.value.condominium.addressNumber) + " - " + _vm._s(_vm.value.condominium.neighborhood) + ", " + _vm._s(_vm.value.condominium.city) + " - " + _vm._s(_vm.value.condominium.state) + ", " + _vm._s(_vm.value.condominium.zipCode) + "\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Administradora:")]), _vm._v(" " + _vm._s(_vm.value.condominium.administrator) + "\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr', {
    staticClass: "mt-2 mb-2"
  })])] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('item-details', {
    attrs: {
      "value": _vm.value
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pt-2": ""
    }
  }, [_c('strong', [_vm._v("Seu pedido:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pt-2": ""
    }
  }, [_c('strong', [_vm._v("Data do agendamento:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pt-2": ""
    }
  }, [_c('strong', [_vm._v("Capacidade de atendimento:")])]), _vm._v(" "), (!_vm.alteredScheduleSaving) ? [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pt-2": "",
      "pr-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.value.code,
      "disabled": _vm.loadingNew || !_vm.scheduleEditing && _vm.value.id !== ''
    },
    on: {
      "input": _vm.updateScheduleCode
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pt-2": "",
      "pr-4": ""
    }
  }, [(_vm.loadingNew || !_vm.scheduleEditing && _vm.value.id !== '') ? _c('v-text-field', {
    attrs: {
      "prepend-icon": "event",
      "disabled": true,
      "readonly": ""
    },
    model: {
      value: (_vm.scheduleDateLabel),
      callback: function($$v) {
        _vm.scheduleDateLabel = $$v
      },
      expression: "scheduleDateLabel"
    }
  }) : _c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "add",
      "append-icon-cb": _vm.dataConfigOpen,
      "disabled": _vm.loadingNew,
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.scheduleDateLabel),
      callback: function($$v) {
        _vm.scheduleDateLabel = $$v
      },
      expression: "scheduleDateLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      'interval-error': _vm.errorDisponibilityInterval
    },
    attrs: {
      "xs4": "",
      "pt-3": ""
    }
  }, [_c('time-schedule')], 1)] : _vm._e(), _vm._v(" "), _c('DateConfig')], 2), _vm._v(" "), (_vm.value.id !== '' && _vm.value.status === 0) ? _c('div', {}, [(_vm.value.status === 0 && !_vm.scheduleEditing) ? _c('v-layout', {
    staticClass: "condominium-box no-top-border text-xs-center mb-3 pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.value.sent) ? _c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.loadingScheduleActions || _vm.alteredScheduleSaving,
      "color": "blue darken-3"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.enableEdit($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("border_color")]), _vm._v(" Editar")], 1)], 1) : (_vm.value.sent) ? _c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": "disabled",
      "color": "blue darken-3"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("border_color")]), _vm._v(" Editar")], 1)], 1) : _vm._e()], 1) : _c('v-layout', {
    staticClass: "condominium-box no-top-border text-xs-center mb-5 pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.loadingScheduleActions,
      "color": "grey darken-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.enableEdit($event)
      }
    }
  }, [_vm._v("cancelar")])], 1), _vm._v(" "), (!_vm.alteredSchedule) ? _c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "blue",
      "disabled": true
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check")]), _vm._v("Confirma alterações")], 1)], 1) : _c('v-flex', [(!_vm.alteredScheduleDateWarning) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "green",
      "disabled": _vm.loadingScheduleActions
    },
    on: {
      "click": _vm.alterSchedule
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check")]), _vm._v("Confirma alterações")], 1) : _c('alter-date-warning', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "green",
      "disabled": _vm.loadingScheduleActions
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check")]), _vm._v("Confirma alterações")], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-619793b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/ScheduleModal/CondominiumBox.vue
// module id = 510
// module chunks = 0 1